<template>
    <div class="about">
        <Visual :title="'ABOUT'" :background="'about'"/>
        <div class="box-wrapper">
            <GradientBox class="about-box" :transition="'gradient-box'">
                <div class="about-box__text is-lato">
                    <p class="title">MAKE ONE WORLD,<br>E-COMMERCE PLATFORM</p>
                    <p class="company">CUBE PLATFORM</p>
                </div>
            </GradientBox>
        </div>
        <div id="content" class="content">
            <Scrollama @step-enter="setVisible" :offset="0.8">
            <div class="content-top">
                <div class="shape-wrapper" v-if="$resize && $mq.above(1024)">
                    <div class="shape1"  v-parallax="0.3"></div>
                    <div class="shape2"  v-parallax="-0.4"></div>
                </div>
                <div class="content-top__inner">
                    <p class="section-title" v-html="$t('about.title')"></p>
                    <p class="desc" v-html="$t('about.desc')"></p>
                </div>
            </div>
            <div class="section01">
                <div class="section01__inner" v-if="$resize && $mq.above(1024)">
                    <p class="section-title" v-html="$t('about.section01.title')"></p>
                    <ul class="teams">
                        <sequential-entrance delay="150" animation="listIn">
                            <li class="team" v-for="(item, index) in teams" :key="index">
                                <p class="symbol-wrapper">
                                    <span :class="['symbol', 'symbol0' + (index + 1)]"></span>
                                </p>
                                <dl class="desc">
                                    <dt v-html="$t(item.main)"></dt>
                                    <dd v-html="$t(item.sub + '01')"></dd>
                                    <dd v-html="$t(item.sub + '02')"></dd>
                                    <dd v-html="$t(item.sub + '03')"></dd>
                                </dl>
                            </li>
                        </sequential-entrance>
                    </ul>
                </div>
                <div class="section01__inner" v-else-if="$resize && $mq.above(320)">
                    <p class="section-title" v-html="$t('about.section01.title')"></p>
                    <ul class="teams">
                        <agile ref="agile" :autoplay="true" :dots="true" v-if="slideLocale">
                        <li class="team" v-for="(item, index) in teams" :key="index">
                            <p class="symbol-wrapper">
                                <span :class="['symbol', 'symbol0' + (index + 1)]"></span>
                            </p>
                            <dl class="desc">
                                <dt v-html="$t(item.main)"></dt>
                                <dd v-html="$t(item.sub + '01')"></dd>
                                <dd v-html="$t(item.sub + '02')"></dd>
                                <dd v-html="$t(item.sub + '03')"></dd>
                            </dl>
                        </li>
                        </agile>
                    </ul>
                </div>
            </div>
            <div class="section02">
                <div class="shape-wrapper" v-if="$resize && $mq.above(1024)">
                    <div class="shape3"  v-parallax="-0.2"></div>
                    <div class="shape4"  v-parallax="0.6"></div>
                </div>
                <div class="section02__inner">
                    <p class="section-title">CI</p>
                    <div class="ci-desc">
                        <p class="cube">
                            <span class="title is-lato">Cube</span>
                            <span class="desc" v-html="$t('about.section02.desc01')"></span>
                        </p>
                        <p class="platform">
                            <span class="title is-lato">Platform</span>
                            <span class="desc" v-html="$t('about.section02.desc02')"></span>
                        </p>
                    </div>
                    <div class="ci-symbol">
                        <div class="symbol-h">
                            <div class="image">
                                <img src="../assets/image/logo/about_ci_h.png" alt="Cubeplatform">
                            </div>
                            <p class="desc is-lato">Horizontal Signature</p>
                        </div>
                        <div class="symbol-v">
                            <div class="image">
                                <img src="../assets/image/logo/about_ci_v.png" alt="Cubeplatform">
                            </div>
                            <p class="desc is-lato">Vertical Signature</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section03">
                <GoogleMaps class="map"></GoogleMaps>
                <div class="section03__inner">
                    <p class="section-title">CONTACT</p>
                    <div class="contact">
                        <p class="address">
                            <span v-html="$t('about.section03.address')"></span>
                        </p>
                        <p class="tel is-lato">
                            <span class="title">Tel</span>
                            <span class="desc">02-2637-2637</span>
                        </p>
                        <p class="fax is-lato">
                            <span class="title">Fax</span>
                            <span class="desc">02-2637-2636</span>
                        </p>
                        <p class="mail is-lato">
                            <span class="title">E-mail</span>
                            <span class="desc">info@cubeplatform.co.kr</span>
                        </p>
                    </div>
                </div>
            </div>
            </Scrollama>
        </div>
    </div>
</template>

<script>
import 'intersection-observer'
import Scrollama from 'vue-scrollama'
import Visual from '@/components/common/Visual'
import GradientBox from '@/components/common/GradientBox'
import GoogleMaps from '@/components/about/GoogleMaps'
export default {
    name: 'About',
    components: { Scrollama, Visual, GradientBox, GoogleMaps },
    metaInfo: {
        titleTemplate: '%s | ABOUT',
        meta: [
            { name: 'description', content: 'MAKE ONE WORLD, E-COMMERCE PLATFORM. CUBE PLATFORM' },
            { name: 'property="og:description"', content: 'MAKE ONE WORLD, E-COMMERCE PLATFORM. CUBE PLATFORM' }
        ]
    },
    data: function () {
        return {
            teams: [
                {
                    title: 'team01',
                    main: 'about.section01.team01.main',
                    sub: 'about.section01.team01.sub'
                }, {
                    title: 'team02',
                    main: 'about.section01.team02.main',
                    sub: 'about.section01.team02.sub'
                }, {
                    title: 'team03',
                    main: 'about.section01.team03.main',
                    sub: 'about.section01.team03.sub'
                }
            ],
            slideLocale: ''
        }
    },
    methods: {
        setVisible: function (el) {
            el.element.classList.add('is-active')
        },
        setSlideLocale: function (val) {
            this.slideLocale = false
            var self = this
            setTimeout(function () {
                self.slideLocale = val
            }, 5)
        }
    },
    computed: {
        getLocale () {
            return this.$store.getters.getLocale
        }
    },
    watch: {
        getLocale: function (val, oldVal) {
            this.setSlideLocale(val)
        }
    },
    mounted () {
        this.slideLocale = this.$store.getters.getLocale
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
@keyframes list-visible {
    0% {transform: translateY(30px); opacity: 0;}
    100% {transform: translateY(0); opacity: 1;}
}
.listIn {
    position: relative;
    animation: list-visible 1000ms;
}
@include over-desktop {
    .box-wrapper {
        position: relative;
        top: -70px;
        width: 1200px;
        margin: 0 auto;
    }
    .about-box {
        width: 100%;
        height: 200px;
        padding: 40px 100px;
        white-space: nowrap;

        &__text {
            color: #fff;
            .title {
                font-size: 32px;
                line-height: 36px;
            }
            .company {
                margin-top: 28px;
                font-size: 14px;
                line-height: 14px;
                letter-spacing: 2px;
            }
        }
    }
    .content {
        position: relative;
        width: 100%;
        margin: -200px auto 0;
        .section-title {
            margin-left: -95px;
            color: #444;
            font-size: 30px;
            line-height: 30px;
            letter-spacing: -1px;

            &::before {
                content: '';
                display: inline-block;
                width: 71px;
                height: 10px;
                margin-right: 25px;
                margin-bottom: 3px;
                background: url(../assets/image/common/before-title.svg) no-repeat center;
                background-size: 100% auto;
                vertical-align: middle;
            }
        }
        .content-top__inner,
        .section01__inner,
        .section02__inner,
        .section03__inner {
            width: 1200px;
            margin: 0 auto;
            padding-left: 95px;
        }
        .content-top {
            overflow: hidden;
            .shape-wrapper {
                position: relative;
                z-index: -1;
                width: 1200px;
                height: 100%;
                margin: 0 auto;
                .shape1 {
                    position: absolute;
                    top: -200px;
                    right: -13%;
                    width: 353px;
                    height: 297px;
                    background: url(../assets/image/about/shape_01.png) no-repeat center;
                    background-size: 100% auto;
                }
                .shape2 {
                    position: absolute;
                    top: 480px;
                    left: -18%;
                    width: 245px;
                    height: 197px;
                    background: url(../assets/image/about/shape_02.png) no-repeat center;
                    background-size: 100% auto;
                }
            }
            &__inner {
                height: 560px;
                padding-top: 240px;
                .desc {
                    margin-top: 50px;
                    color: #999;
                    font-size: 16px;
                    line-height: 24px;
                }
            }
        }
        .section01 {
            position: relative;
            overflow: hidden;
            background: url(../assets/image/about/section01-background.png) no-repeat center;
            background-size: cover;
            background-attachment: fixed;
            &::before {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: #434063;
                opacity: 0.85;
            }
            .section-title {
                color: #fff;

                &::before {
                    background: url(../assets/image/common/before-title-dark.svg) no-repeat center;
                    background-size: 100% auto;
                }
            }
            &__inner {
                position: relative;
                height: 560px;
                padding-top: 100px;

                .teams {
                    position: absolute;
                    top: 110px;
                    right: 0;

                    .team {
                        float: left;
                        position: relative;
                        width: 200px;
                        margin-left: 100px;

                        &:first-child {
                            margin-left: 0;
                            .symbol-wrapper::before {
                                display: none;
                            }
                        }

                        .symbol-wrapper {
                            position: relative;
                            width: 200px;
                            height: 200px;
                            border: 1px solid rgba(255, 255, 255, 0.8);
                            border-radius: 50%;

                            &::before {
                                content: '';
                                display: block;
                                position: absolute;
                                top: 50%;
                                left: -85px;
                                width: 71px;
                                height: 10px;
                                background: url(../assets/image/common/before-title-dark.svg) no-repeat center;
                                background-size: 100% auto;
                                opacity: 0.5;
                                transform: translateY(-50%);
                            }

                            .symbol {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                display: block;
                                width: 100%;
                                height: 100%;
                                transform: translate(-50%, -50%);

                                @for $i from 1 to 4 {
                                            &.symbol0#{$i} {
                                            background: url(../assets/image/about/icon0#{$i}.png) no-repeat center;
                                        }
                                    }
                                }
                            }
                        .desc {
                            margin-top: 30px;
                            text-align: center;
                            // white-space: nowrap;

                            dt {
                                margin-bottom: 15px;
                                color: #fff;
                                font-size: 22px;
                                letter-spacing: -2px;
                            }
                            dd {
                                margin-top: 5px;
                                color: #fff;
                                font-size: 15px;
                                letter-spacing: -2px;
                            }
                        }
                    }
                }
            }
        }
        .section02 {
            overflow: hidden;
            .shape-wrapper {
                position: relative;
                width: 1200px;
                height: 100%;
                margin: 0 auto;
                transform: translateY(-100px);
                .shape3 {
                    position: absolute;
                    top: 150px;
                    right: -5.5%;
                    width: 133px;
                    height: 152px;
                    background: url(../assets/image/about/shape_03.png) no-repeat center;
                    background-size: 100% auto;
                }
                .shape4 {
                    position: absolute;
                    top: 100px;
                    left: -16%;
                    width: 321px;
                    height: 322px;
                    background: url(../assets/image/about/shape_04.png) no-repeat center;
                    background-size: 100% auto;
                }
            }
            &__inner {
                position: relative;
                height: 490px;
                padding-top: 110px;
                .section-title {
                    font-family: 'Lato', sans-serif;
                }
                .ci-desc {
                    margin-top: 50px;

                    .title {
                        display: block;
                        color: #444;
                        font-weight: 700;
                        font-size: 16px;
                    }
                    .desc {
                        display: block;
                        margin-top: 8px;
                        color: #999;
                        font-size: 16px;
                        letter-spacing: -1px;
                    }
                    .platform {
                        margin-top: 30px;
                    }
                }
                .ci-symbol {
                    position: absolute;
                    top: 110px;
                    right: 0;

                    & > div {
                        float: left;
                        margin-left: 30px;

                        &:first-child {
                            margin-left: 0;
                        }
                    }
                    .image {
                        position: relative;
                        width: 390px;
                        height: 237px;
                        border: 1px solid #e1e1e1;
                        background: #fff;
                    }
                    .desc {
                        margin-top: 15px;
                        text-align: center;
                        color: #444;
                        font-weight: 700;
                        font-size: 16px;
                        line-height: 24px;
                    }
                    .symbol-h {
                        .image img {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            max-width: 50%;
                            height: auto;
                        }
                    }
                    .symbol-v {
                        .image img {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            max-height: 55%;
                            width: auto;
                        }
                    }
                }
            }
        }
        .section03 {
            .map {
                height: 560px;
            }
            &__inner {
                position: relative;
                height: 345px;
                padding-top: 110px;
                .section-title {
                    font-family: 'Lato', sans-serif;
                }
                .contact {
                    display: block;
                    position: absolute;
                    top: 110px;
                    right: 0;
                    width: 100%;
                    padding-left: 440px;

                    & > p {
                        margin-top: 10px;

                        &:first-child {
                            margin-top: 0;
                        }
                    }
                    .address > span {
                        color: #666;
                        font-size: 16px;
                        line-height: 24px;
                        letter-spacing: -1px;
                    }
                    .title {
                        color: #444;
                        font-weight: 700;
                        font-size: 16px;
                        line-height: 24px;
                    }
                    .desc {
                        position: absolute;
                        left: 0;
                        padding-left: 550px;
                        color: #999;
                        font-size: 16px;
                        line-height: 24px;
                    }
                }
            }
        }
    }
    .gradient-box-enter-active,
    .gradient-box-leave-active {
        transition: transform 1000ms;
    }
    .gradient-box-enter,
    .gradient-box-leave-active {
        transform: translateY(25px);
    }

    .content-top {
        .section-title {
            opacity: 0;
            transform: translateX(-40px);
            transition: opacity 1000ms 250ms, transform 1000ms 250ms;
        }
        .desc {
            opacity: 0;
            transform: translateY(40px);
            transition: opacity 1000ms 500ms, transform 1000ms 500ms;
        }
    }
    .content-top.is-active {
        .section-title {
            opacity: 1;
            transform: translateX(0);
        }
        .desc {
            opacity: 1;
            transform: translateY(0);
        }
    }
    .section01 {
        .section-title {
            opacity: 0;
            transform: translateX(-40px);
            transition: opacity 1000ms, transform 1000ms;
        }
        .teams {
            display: none;
        }
    }
    .section01.is-active {
        .section-title {
            opacity: 1;
            transform: translateX(0);
        }
        .teams {
            display: block;
        }
    }
    .section02 {
        .section-title {
            opacity: 0;
            transform: translateX(-40px);
            transition: opacity 1000ms, transform 1000ms;
        }
        .ci-desc {
            opacity: 0;
            transform: translateY(40px);
            transition: opacity 1000ms 250ms, transform 1000ms 250ms;
        }
        .ci-symbol {
            opacity: 0;
            transform: translateX(40px);
            transition: opacity 1000ms 500ms, transform 1000ms 500ms;
        }
    }
    .section02.is-active {
        .section-title {
            opacity: 1;
            transform: translateX(0);
        }
        .ci-desc {
            opacity: 1;
            transform: translateY(0);
        }
        .ci-symbol {
            opacity: 1;
            transform: translateX(0);
        }
    }
    .section03 {
        .section-title {
            opacity: 0;
            transform: translateX(-40px);
            transition: opacity 1000ms 250ms, transform 1000ms 250ms;
        }
        .contact {
            opacity: 0;
            transform: translateY(40px);
            transition: opacity 1000ms 500ms, transform 1000ms 500ms;
        }
    }
    .section03.is-active {
        .section-title {
            opacity: 1;
            transform: translateX(0);
        }
        .contact {
            opacity: 1;
            transform: translateY(0);
        }
    }
}
@include desktop-small {
    .box-wrapper {
        width: calc(1024px - 56px);
    }
    .content {
        .content-top__inner,
        .section01__inner,
        .section02__inner,
        .section03__inner {
            width: calc(1024px - 56px);
            margin: 0 auto;
        }
        .content-top,
        .section01 {
            .shape-wrapper {
                width: 1024px;
            }
        }
        .section01 {
            &__inner {
                height: 600px;
            }
            .teams {
                top: 170px;
                left: 95px
            }
        }
        .section02 {
            &__inner {
                .ci-symbol {
                    .symbol-h,
                    .symbol-v {
                        .image {
                            width: 336px;
                            height: 204px;
                        }
                    }
                    .symbol-v {
                        margin-left: 20px;
                    }
                }
            }
        }
    }
}
@include under-tablet {
    .box-wrapper {
        width: calc(100% - 56px);
        margin-left: 28px;
        transform: translateY(-10vw);
    }
    .about-box {
        padding: 6vw;
        &__text {
            color:#fff;
            .title {
                font-size: 4.4vw;
            }
            .company {
                margin-top: 6vw;
                font-size: 1.8vw;
                opacity: 0.7;
            }
        }
    }
    .section-title {
        font-size: 5.4vw;
        line-height: 8vw;
        text-align: center;

        &::before {
            content: '';
            display: block;
            margin: 0 auto 4vw;
            width: 20vw;
            height: 3vw;
            background: url(../assets/image/common/before-title.svg) no-repeat center;
            background-size: 100% auto;
        }
    }
    .content-top {
        padding-bottom: 10vw;
    }
    .section01,
    .section02,
    .section03 {
        padding: 10vw 0;
    }
    .content-top,
    .section02,
    .section03 {
        &__inner {
            padding: 0 28px;
        }
    }
    .content-top {
        .desc {
            margin-top: 8vw;
            color: #999;
            font-size: 4vw;
            line-height: 5vw;
            letter-spacing: -0.3vw;
            text-align: center;
        }
    }
    .section01 {
        position: relative;
        background: url(../assets/image/about/section01-background.png) no-repeat center;
        background-size: cover;
        // background-attachment: fixed;
        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #434063;
            opacity: 0.85;
        }
        &__inner {
            position: relative;
            z-index: 1;
            .section-title {
                color: #fff;
                &::before {
                    background: url(../assets/image/common/before-title-dark.svg) no-repeat center;
                    background-size: 100% auto;
                }
            }
            .teams {
                padding-top: 8vw;
                .team {
                    .symbol-wrapper{
                        position: relative;
                        width: 44vw;
                        height: 44vw;
                        margin: 0 auto;
                        border: 1px solid rgba(255, 255, 255, 0.8);
                        border-radius: 50%;
                        .symbol {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            display: block;
                            width: 100%;
                            height: 100%;
                            transform: translate(-50%, -50%);

                            @for $i from 1 to 4 {
                                    &.symbol0#{$i} {
                                    background: url(../assets/image/about/icon0#{$i}.svg) no-repeat center;
                                    background-size: 50% auto;
                                }
                            }
                        }
                    }
                    .desc {
                        margin-top: 6vw;
                        min-height: 27vw;
                        color: #fff;
                        font-size: 4vw;
                        line-height: 5vw;
                        text-align: center;
                        dt {
                            font-weight: 700;
                            margin-bottom: 4vw;
                        }
                        dd {
                            margin-bottom: 1vw;
                        }
                    }
                }
            }
        }
    }
    .section02 {
        .section-title {
            font-family: 'Lato', sans-serif;
        }
        .ci-desc {
            overflow: hidden;
            margin-top: 8vw;
            .cube,
            .platform {
                float: left;
                width: 50%;
                font-size: 4vw;
                text-align: center;
                .title {
                    color: #444;
                    display: block;
                    margin-bottom: 1vw;
                    font-weight: 700;
                }
                .desc {
                    color: #999;
                    letter-spacing: -0.2vw;
                }
            }
            .platform {
                // padding-right: 5vw;
            }
        }
        .ci-symbol {
            .symbol-h,
            .symbol-v {
                .image {
                    position: relative;
                    width: 100%;
                    height: 58vw;
                    margin-top: 10vw;
                    border: 1px solid #ddd;
                    background: #fff;
                }
                .desc {
                    margin-top: 3vw;
                    color: #444;
                    font-weight: 700;
                    font-size: 4vw;
                    text-align: center;
                }
            }
            .symbol-h {
                .image img {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    max-width: 50%;
                    height: auto;
                }
            }
            .symbol-v {
                .image img {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    max-height: 55%;
                    width: auto;
                }
            }
        }
    }
    .section03 {
        padding-top: 0;
        .map {
            width: 100vw;
            height: 60vw;
        }
        &__inner {
            padding-top: 10vw;
            font-size: 4vw;
            line-height: 5vw;
            text-align: center;
            .section-title {
                font-family: 'Lato', sans-serif;
            }
            .address {
                margin-top: 6vw;
                color: #666;
                font-size: 3.8vw;
                letter-spacing: -0.2vw;
            }
            .tel,
            .fax,
            .mail {
                margin-top: 3vw;
                .title {
                    display: block;
                    font-weight: 700;
                    color: #444;
                }
                .desc {
                    display: block;
                    margin-top: 1vw;
                    color: #888;
                }
            }
            .tel {
                margin-top: 8vw;
            }
        }
    }

    .content-top {
        .section-title {
            opacity: 0;
            transform: translateY(-4vh);
            transition: opacity 1000ms 250ms, transform 1000ms 250ms;
        }
        .desc {
            opacity: 0;
            transform: translateY(-2vh);
            transition: opacity 1000ms 500ms, transform 1000ms 500ms;
        }
    }
    .content-top.is-active {
        .section-title {
            opacity: 1;
            transform: translateY(0);
        }
        .desc {
            opacity: 1;
            transform: translateY(0);
        }
    }
    .section01 {
        .section-title {
            opacity: 0;
            transform: translateY(-4vh);
            transition: opacity 1000ms 250ms, transform 1000ms 250ms;
        }
        .teams {
            opacity: 0;
            transition: opacity 1000ms 500ms;
        }
    }
    .section01.is-active {
        .section-title {
            opacity: 1;
            transform: translateY(0);
        }
        .teams {
            opacity: 1;
        }
    }
    .section02 {
        .section-title {
            opacity: 0;
            transform: translateY(-4vh);
            transition: opacity 1000ms 250ms, transform 1000ms 250ms;
        }
        .ci-desc {
            opacity: 0;
            transform: translateY(-4vh);
            transition: opacity 1000ms 250ms, transform 1000ms 250ms;
        }
        .ci-symbol {
            opacity: 0;
            transform: translateX(4vw);
            transition: opacity 1000ms 500ms, transform 1000ms 500ms;
        }
    }
    .section02.is-active {
        .section-title {
            opacity: 1;
            transform: translateY(0);
        }
        .ci-desc {
            opacity: 1;
            transform: translateY(0);
        }
        .ci-symbol {
            opacity: 1;
            transform: translateX(0);
        }
    }
    .section03 {
        .section-title {
            opacity: 0;
            transform: translateY(-4vh);
            transition: opacity 1000ms 250ms, transform 1000ms 250ms;
        }
        .contact {
            opacity: 0;
            transform: translateY(-4vh);
            transition: opacity 1000ms 500ms, transform 1000ms 500ms;
        }
    }
    .section03.is-active {
        .section-title {
            opacity: 1;
            transform: translateY(0);
        }
        .contact {
            opacity: 1;
            transform: translateY(0);
        }
    }
}
@include mobile {
    .box-wrapper {
        width: calc(100% - 40px);
        margin-left: 20px;
    }
    .content-top,
    .section02,
    .section03 {
        &__inner {
            padding: 0 20px;
        }
    }
    .section03 {
        &__inner {
            padding-top: 10vw;
        }
    }
}
</style>

<style>
.teams .agile__dots {
    display: none;
}
.teams .agile__arrow {
    position: absolute;
    top: 22vw;
    width: 6vw;
    height: 6vw;
    fill: transparent;
    border: solid #fff;
    border-width: 1px 1px 0 0;
    opacity: 0.5;
    cursor: pointer;
}
.teams .agile__arrow svg {
    height: 8vw;
}
.teams .agile__arrow.agile__arrow--prev {
    left: 50%;
    transform: translate(-36vw, -50%) rotate(-135deg);
}
.teams .agile__arrow.agile__arrow--next {
    right: 50%;
    transform: translate(36vw, -50%) rotate(45deg);
}
@media (min-width: 320px) and (max-width: 767px) {
    .teams .agile__arrow.agile__arrow--prev {
        left: 50%;
    }
    .teams .agile__arrow.agile__arrow--next {
        right: 50%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/About.vue